/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, file: NonNullable<unknown> }} Csv_Import_PreviewInputs */



/**
* | output |
* | --- |
* | "{count} row(s) ready from {file}." |
*
* @param {Csv_Import_PreviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const csv_import_preview = /** @type {((inputs: Csv_Import_PreviewInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_Import_PreviewInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} ligne(s) prête(s) à partir de ${i?.file}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} fila(s) lista(s) a partir de ${i?.file}.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} linha(s) pronta(s) a partir de ${i?.file}.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} riga/e pronta/e a partire da ${i?.file}.`)
	return /** @type {LocalizedString} */ (`${i?.count} row(s) ready from ${i?.file}.`)
});